/**
 * @generated SignedSource<<d155cb2e0d5640cdfc10ad50cf7d787d>>
 * @relayHash 7b6d9b50a8d296f1b6e608205a17bd15
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 22cb9b11a294000ed03564f054cbd9a524df4c24bfed99bd87a8c708a4bdf01b

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { profileMenuQuery } from './profileMenuQuery.graphql';

const node: PreloadableConcreteRequest<profileMenuQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "22cb9b11a294000ed03564f054cbd9a524df4c24bfed99bd87a8c708a4bdf01b",
    "metadata": {},
    "name": "profileMenuQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
